import storage from 'store'
const VERSION = require('_r/package.json').version
const keyName = `LEELENOFFIACCOUNT${VERSION}`

console.log('VERSION:', VERSION)
storage.each(function (value, key) {
  if (key.includes('LEELENOFFIACCOUNT') && key !== keyName) {
    storage.remove(key)
  }
})
export default store => {
  const localStore = storage.get(keyName)
  if (localStore) {
    store.replaceState(localStore)
    // 权限需要重新获取
    localStore.user.userStatus = undefined
  }
  store.subscribe((mutation, state) => {
    storage.set(keyName, state)
  })
}
